'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  PAYPAL_PURCHASE_FAILED: null,
  PROVIDER_ERROR: null
});
export var isProviderError = function isProviderError(message) {
  return message.startsWith('Paypal exception. Failed to create payment: Account ') && message.endsWith(' is restricted');
};